/** GET de ítems de menú: trae los `MenuItem` del usuario logueado para armar la navegación de la app. */
import { API_ENDPOINTS } from "../apiEndpoints";
import { apiCall } from "../apiHelper";
import { MenuItem, LoggedUserInnerwork } from "@/types";

export const GETMenuItems = (loggedUserInnerwork: LoggedUserInnerwork) =>
  apiCall<MenuItem[]>({
    method: "get",
    maxBodyLength: Infinity,
    url: `${API_ENDPOINTS.GET_ITEMS_MENU}?codUsuario=${loggedUserInnerwork.codUsuario ?? ""}`,
  });
